import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IGetCities, IItemForGetShortInfo } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCities } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';
import style from './CitySelect.module.scss';

interface ICitySelect {
	IDSelectedCountry: Nullable<string>;
	setIDCity: (value: Nullable<string>) => void;
	setFetchedCities: (value: IItemForGetShortInfo[]) => void;
}

const CitySelect: React.FC<ICitySelect> = ({ IDSelectedCountry, setIDCity, setFetchedCities }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCities, string>(
		IDSelectedCountry ? getCities : null,
		IDSelectedCountry || '',
	);
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCity') }], [t]);

	useEffect(() => {
		refetch();
	}, [IDSelectedCountry]);

	useEffect(() => {
		response && setFetchedCities(response.data.cities);
	}, [response]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="CitySelect"
			name="IDSelectedCity"
			label="cityLabel"
			options={response?.data.cities}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDCity}
			disabled={!IDSelectedCountry}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CitySelect);
